import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const SmileyDark = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M11.99 2.45117C6.47 2.45117 2 6.93117 2 12.4512C2 17.9712 6.47 22.4512 11.99 22.4512C17.52 22.4512 22 17.9712 22 12.4512C22 6.93117 17.52 2.45117 11.99 2.45117ZM8.5 8.45117C9.33 8.45117 10 9.12117 10 9.95117C10 10.7812 9.33 11.4512 8.5 11.4512C7.67 11.4512 7 10.7812 7 9.95117C7 9.12117 7.67 8.45117 8.5 8.45117ZM12 18.4512C9.72 18.4512 7.78 16.7912 7 14.4512H17C16.22 16.7912 14.28 18.4512 12 18.4512ZM15.5 11.4512C14.67 11.4512 14 10.7812 14 9.95117C14 9.12117 14.67 8.45117 15.5 8.45117C16.33 8.45117 17 9.12117 17 9.95117C17 10.7812 16.33 11.4512 15.5 11.4512Z"
    />
  </svg>
);
